import { defineComponent as o, useSlots as n, openBlock as r, createBlock as s, unref as i, withCtx as c, renderSlot as u, createElementBlock as g, createElementVNode as t, normalizeStyle as f, toDisplayString as a } from "vue";
import y from "./ghl-ui.es366.js";
const m = { key: 1 }, h = { class: "n-progress-text__percentage" }, p = { class: "n-progress-text__unit" }, b = o({
  name: "UIProgress",
  inheritAttrs: !1
}), S = o({
  ...b,
  props: {
    percentage: {
      type: Number
    },
    type: {
      type: String,
      default: "line"
    },
    processing: {
      type: Boolean,
      default: !1
    },
    indicatorPlacement: {
      type: String,
      default: "inside"
    },
    status: {
      type: String
    },
    showIndicator: {
      type: Boolean,
      default: void 0
    },
    borderRadius: {
      type: [Number, String],
      default: void 0
    },
    circleGap: {
      type: Number,
      default: 1
    },
    color: {
      type: [String, Array],
      default: void 0
    },
    fillBorderRadius: {
      type: [Number, String],
      default: void 0
    },
    gapDegree: {
      type: Number,
      default: 75
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: void 0
    },
    indicatorTextColor: {
      type: String,
      default: void 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    railColor: {
      type: [String, Array],
      default: void 0
    },
    railStyle: {
      type: [String, Object, Array],
      default: void 0
    },
    strokeWidth: {
      type: Number,
      default: 7
    },
    unit: {
      type: String,
      default: "%"
    }
  },
  setup(e) {
    const l = n();
    return (d, x) => (r(), s(i(y), {
      "indicator-placement": e.indicatorPlacement,
      percentage: e.percentage,
      processing: e.processing,
      "show-indicator": e.showIndicator,
      status: e.status,
      type: e.type,
      "border-radius": e.borderRadius,
      "circle-gap": e.circleGap,
      color: e.color,
      "fill-border-radius": e.fillBorderRadius,
      "gap-degree": e.gapDegree,
      "gap-offset-degree": e.gapOffsetDegree,
      height: e.height,
      "indicator-text-color": e.indicatorTextColor,
      "offset-degree": e.offsetDegree,
      "rail-color": e.railColor,
      "rail-style": e.railStyle,
      "stroke-width": e.strokeWidth,
      unit: e.unit
    }, {
      default: c(() => [
        i(l).default ? u(d.$slots, "default", { key: 0 }) : (r(), g("div", m, [
          t("div", {
            class: "n-progress-text",
            role: "none",
            style: f(e.indicatorTextColor ? { color: e.indicatorTextColor } : {})
          }, [
            t("span", h, a(e.percentage), 1),
            t("span", p, a(e.unit), 1)
          ], 4)
        ]))
      ]),
      _: 3
    }, 8, ["indicator-placement", "percentage", "processing", "show-indicator", "status", "type", "border-radius", "circle-gap", "color", "fill-border-radius", "gap-degree", "gap-offset-degree", "height", "indicator-text-color", "offset-degree", "rail-color", "rail-style", "stroke-width", "unit"]));
  }
}), k = S;
export {
  k as default
};
